<template>
  <dashboard />
</template>

<script>
import Dashboard from "@/components/Dashboard/Dashboard";
export default {
  name: "DashboardView",
  components: {
    dashboard: Dashboard,
  },
};
</script>

<style scoped></style>
